import axios from 'axios'

// TODO: consider moving these to actions in the cart store as they're only used during checkout
export async function saveTransaction (data) {
  // TODO: replace this with hubRequest from utilities.js
  const response = await axios.post(`${process.env.VUE_APP_SERVER}/api/saveTransaction`, data)
  return response
}

export async function flagTransaction (UUID) {
  // TODO: replace this with hubRequest from utilities.js
  const response = await axios.post(`${process.env.VUE_APP_SERVER}/api/flagTransaction`, { UUID })
  return response
}
